import { isNumber } from 'lodash';

/**
 * @type {function}
 * @desc Return image dimensions from a `File` object.
 * @example
 * import * as imageDimensions from 'utils/imageDimensions';
 * const result = imageDimensions.fromFile( File );
 */
export const fromFile = ( file ) => {

    // create `Image` object
    const img = new Image();

    return new Promise( ( resolve, reject ) => {

        // on success
        img.onload = function() {
            
            // get `width` and `height` of the image
            const { width, height } = this;

            if( ! isNumber( width ) || ! isNumber( height ) || 0 >= width || 0 >= height ) {
                reject();
            } else {
                resolve( { width, height } );
            }
        };

        // on error
        img.onerror = function() {
            reject();
        };

        // add source from the file
        img.src = window.URL.createObjectURL( file );

    } );
};
